// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3PYju","footer":"ModalFilter_footer__xCb_n"};